import { timezoneFromCountry } from '@archipro-website/localisation';
import { resolveZonedInstant } from './zoned-instant';

/**
 * US public launch of the product directory.
 *
 * The clock counts down to a single absolute instant — midnight on the launch
 * date read in the US market timezone — so the remaining time is the same for
 * every visitor; only the target is US-local. Deriving the zone from
 * `timezoneFromCountry` keeps it tied to the market's declared timezone rather
 * than a second copy of it.
 */
export const PRODUCT_LAUNCH_TIME_ZONE = timezoneFromCountry('US');

/** Wall-clock launch moment, read in {@link PRODUCT_LAUNCH_TIME_ZONE}. */
export const PRODUCT_LAUNCH_WALL_CLOCK = '2026-11-01T00:00:00';

/** Launch instant as a UTC epoch, resolved once at module load. */
export const PRODUCT_LAUNCH_INSTANT_MS = resolveZonedInstant(
    PRODUCT_LAUNCH_WALL_CLOCK,
    PRODUCT_LAUNCH_TIME_ZONE,
);

/** Caption shown above the digits (Figma `4385:20764`). */
export const PRODUCT_LAUNCH_CAPTION = 'ARCHIPRO USA PUBLIC LAUNCH';
